import React, { createContext, useContext, useReducer } from 'react';
const AppContext = createContext();

const initialState = {
    user: null,
    token: null,
    establishmentSelected: null,
    establishments: null,
    theme: 'light',
};

const reducer = (state, action) => {
    const { type, value } = action;
    console.log(value);
    switch (type) {
        case 'SET_SESSION': {
            return {
                ...state,
                user: value,
                token: value.token,
                establishmentSelected: value.establishments.length > 1 ? null : value.establishments,
                establishments: value.establishments,
            };
        }
        case 'REMOVE_SESSION' : {
            return {
                ...state,
                user: null,
                token: null,
                establishmentSelected: null,
            }
        }
        case 'SET_ESTABLISHMENT_SELECTED': {
            return {
                ...state,
                establishmentSelected: value,
            }
        }
        case 'SET_THEME':
            return {
                ...state,
                theme: value,
            }
        default: { return state; }
    }
};

export const useSessionContext = () => useContext(AppContext);

export const SessionProvider = ({ children }) => {

    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <AppContext.Provider value={{ ...state, dispatch }}>
            {children}
        </AppContext.Provider>
    );

};
